export function capitalizeFirstLetter(str: string): string {
  if (!str) {
    return '';
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function filterPTQSData<T extends { PTQS?: number }>(data: T[] | undefined): T[] | undefined {
  if (!data || !Array.isArray(data)) {
    return undefined;
  }
  const firstFilteredData = data.filter((row) => (row.PTQS ? row.PTQS !== -1 && row.PTQS < 3 : false));
  if (firstFilteredData.length !== 0) {
    return firstFilteredData;
  }
  const secondFilteredData = data.filter((row) => (row.PTQS ? row.PTQS !== -1 : false));
  if (secondFilteredData.length !== 0) {
    return secondFilteredData;
  }
  return data;
}

export function toDateOnly(date: Date | string): string {
  const d = new Date(date);
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}
